import React, { useEffect, useState } from 'react';
import { EmpleadosAdapter } from '../../../../../infraestructure/persistence/rest/EmpleadosAdapter';
import { useNotifications } from '../../../../../shared/hooks/Notifications';
import { ServerErrorMessage } from '../../../../../shared/utils/error';
import ComboValidaddoresAS400 from './combo';

//import { URLEMPLEADOS } from './constants';

export const ComboValidadoresAS400Container = (props: any) => {
  
  const{initialSelection,selectedOptions}=props;
  
  const api = new EmpleadosAdapter();
  const { exceptionError, resultError } = useNotifications();
  let [data, setData] = useState<any>(undefined)
  let result: any;
  // let _initialSelection:any = [];
  // let _selectedOptions:any = [];
  //let [selectedOptions, setSelectedOptions] = useState<any>(props.selectedOptions);
  
  useEffect(()=>{getValidadores();},[])
	
  // useEffect(()=>{
  //   console.log('es objeto ', typeof props.selectedOptions[0] === 'object')
  //   setSelectedOptions(props.selectedOptions)},[props.selectedOptions])

  const getValidadores = async() =>{
    try {
      result =  await api.ListarValidadoresAS400();
        if(result && result!=="")
	    {
            setData([...result.data]);
        }else{resultError()}
    } catch (error) {
      let exception = ServerErrorMessage(error);
      exceptionError(exception)
    }
  }

  // _initialSelection = typeof props.selectedOptions[0] !== 'object' ? props.selectedOptions : null; 
  // _selectedOptions = _initialSelection===null ? props.selectedOptions: [];
  //{...{...props,...{selectedOptions:_selectedOptions}}}
  return <ComboValidaddoresAS400 {...props} options={data}/>
};

export default ComboValidadoresAS400Container;